export default {"src":"/_next/static/media/11-popsugar-logo.d454c3c6.svg","height":26,"width":42};